export const UPDATE_TEXT_INPUT = 'UPDATE_TEXT_INPUT';
export const UPDATE_COLUMN_TEXT_INPUT = 'UPDATE_COLUMN_TEXT_INPUT';
export const CHANGE_PROFILE_STATUS = 'CHANGE_PROFILE_STATUS';
export const UNLOCK_AUDIO_DIALOG_SHOWN = 'UNLOCK_AUDIO_DIALOG_SHOWN';
